import React from 'react';
import './ProductGrid.css';

function ProductGrid({ productData, openModal }) {
    // 過濾掉價格為0的商品
    const filteredProductData = productData.filter(item => {
        const price = item.system_price;
        return price && price !== 0 && price !== "0";
    });

    // 你可以根據 series 名稱決定顏色 class
    function getSeriesClass(series) {
        switch (series) {
            case '綜合':
                return 'product-series-green';
            case '地區限定':
                return 'product-series-orange';
            case '小物盲包':
                return 'product-series-blue';
            // ...依需求增加
            default:
                return 'product-series-yellow'; // 預設顏色
        }
    }

    // 添加時間戳到圖片 URL
    const getImageUrlWithTimestamp = (url) => {
        if (!url) return '/404.jpg';
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}t=${Date.now()}`;
    };

    return (
        <div className="product-grid">
            {filteredProductData.map((item, index) => (
                <div className="product-card" key={index}>
                    {/* 活動 event 圖示移到 product-card 內、product-image-wrapper 外 */}
                    {item.system_date && item.system_date.includes("活動") && (
                        <img
                            src="/event.webp"
                            alt="活動"
                            className="event-badge"
                        />
                    )}
                    <div className="product-image-wrapper">
                        <img 
                            src={getImageUrlWithTimestamp(item.imageUrl)} 
                            alt={item.name} 
                            className="product-image" 
                            onClick={() => openModal(item.imageUrl, item.barcode)}
                            onError={(e) => {
                                e.target.src = '/404.jpg';
                            }} 
                        />
                        {item.product_info && (
                            <div className="product-tag">{item.product_info}</div>
                        )}
                    </div>
                    <div className="barcode-text">
                        {item.barcode}
                    </div>
                    <div className={`product-series ${getSeriesClass(item.series)}`}>
                        {item.series}
                    </div>
                    <div className={`product-info product-info-${index}`}>
                        <p className={`product-type product-type-${index}`}>
                            {[item.product_type, item.features]
                                .filter(Boolean)
                                .join(' ')}
                        </p>
                        <p className={`product-roles product-roles-${index}`}>
                            {[item.role1, item.role2, item.role3, item.specification]
                                .filter(Boolean)
                                .join(' ')}

                           
                        </p>
                        
                        <p className={`product-price product-price-${index}`}>
                            {item.system_price}元
                        </p>
                    </div>
                    {/* 
                        你可以在 CSS 針對 .product-info-0, .product-info-1 ... 
                        或 .product-type-0, .product-roles-0, .product-price-0 
                        加上不同特效，例如：
                        .product-info-0 { animation: fadeIn 1s; }
                        .product-type-1 { color: red; }
                        ...依照 index 動態渲染不同效果
                    */}
                </div>
            ))}
        </div>
    );
}

export default ProductGrid; 